import {
  withTranslation,
} from 'react-i18next';

import ThQtyView from './ThQtyView';

const TranslatedComponent = withTranslation()(ThQtyView);

const Component = TranslatedComponent;

export default Component;
